module.exports = __webpack_public_path__ + "static/img/snapshot-flyer-permuteo.aa7b17a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pages/thumb/snapshot-flyer-permuteo.png
// module id = pWCI
// module chunks = 1